import React, { forwardRef } from "react";
import * as c from "./pricingPlan.module.scss";
import IconCheckmark from "@components/icons/iconCheckmark";
import classNames from "classnames";
import { UnlimitedBackground, EssentialsBackground, StandardBackground } from "./pricingPlanBgs";

const planStyles = {
  Essentials: {
    colorClass: c.essentialsTitle,
    background: <EssentialsBackground />,
  },
  Standard: {
    colorClass: c.standardTitle,
    background: <StandardBackground />,
  },
  Unlimited: {
    colorClass: c.unlimitedTitle,
    background: <UnlimitedBackground />,
  },
};

const PricingPlan = ({ name, price, mainLimit, aspects, mostPopular }, ref) => {
  return (
    <div className={c.background} ref={ref}>
      {planStyles[name].background}
      <div className={c.container}>
        <div className={c.header}>
          <div className={c.name}>
            <h6 className={classNames("h6", c.name, planStyles[name].colorClass)}>{name}</h6>
            {mostPopular && <p className={classNames("eyebrow2", c.badge)}>Most Popular</p>}
          </div>

          <div className={c.price}>
            <h2 className="h2">${price}</h2>
            <p className={classNames("p4", c.pricePeriod)}>/ month</p>
          </div>
          <p className={classNames("p3")}>{mainLimit}</p>
        </div>
        <hr className={c.divider} />
        <div className={c.aspects}>
          {aspects.map((a, idx) => (
            <div className={c.aspect} key={idx} style={{ display: "flex" }}>
              <IconCheckmark className={planStyles[name].colorClass} />
              <p className="p4">
                <span dangerouslySetInnerHTML={{ __html: a }} />
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default forwardRef(PricingPlan);
